<div class="video_popup_cont">
	<iframe *ngIf="componentLoaded" [src]="safeURL" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen
			frameborder="0" height="315"
			title="YouTube video player"
			width="560">
	</iframe>
	<div (click)="closeVideo()" class="video_popup_cont_overlay">
		<span class="material-symbols-outlined">
			close
		</span>
	</div>
</div>
